import { styled } from '@mui/material';

const Section5Container = styled('section')(({ theme }) => ({
  maxWidth: 1500,
  margin: '0 auto',
  display: 'flex',
  width: '100%',
  gap: 120,
  padding: '48px 64px',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 1rem',
  },
  '& div.content': {
    flexBasis: '50%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    '& div.header': {
      maxWidth: 526,
      marginBottom: 32,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: 32,
      [theme.breakpoints.down('lg')]: {
        padding: '0 32px',
      },
      h2: {
        fontSize: 32,
        fontWeight: 700,
        lineHeight: '48px',
        color: '#04246B',
      },
      h4: {
        fontSize: 24,
        lineHeight: '36px',
      },
    },
    p: {
      maxWidth: 526,
      fontSize: 18,
      lineHeight: '28px',
      textAlign: 'justify',
      [theme.breakpoints.down('md')]: {
        textAlign: 'center',
      },
    },
  },
  '& div.image': {
    flexBasis: '50%',
    textAlign: 'center',
    maxWidth: 526,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    img: {
      maxWidth: '100%',
      borderRadius: 16,
      height: 728,
      objectFit: 'cover',
      boxShadow: '16px 8px 48px 0px rgba(0, 0, 0, 0.25)',
    },
  },
}));

const Section5 = () => {
  return (
    <Section5Container>
      <div className="content">
        <div className="header">
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="101" viewBox="0 0 100 101" fill="none">
            <circle cx="50" cy="51" r="48.5" fill="white" stroke="#CDA07D" stroke-width="3" />
            <path
              d="M50.7068 19.0005C49.8337 19.0005 48.9468 19.0601 48.0459 19.164C43.2509 19.7198 39.0656 21.6018 36.1138 24.3C33.1481 26.9996 31.3742 30.6139 31.8177 34.4389C32.2057 37.8481 34.2845 40.7029 37.2363 42.6708C37.5966 41.8116 38.054 41.0217 38.5113 40.3842C36.0722 38.7766 34.5755 36.6008 34.2983 34.1479C33.9796 31.4177 35.2268 28.6627 37.7352 26.3677C40.2575 24.0713 44.0131 22.3404 48.3508 21.8387C52.6885 21.3357 56.7491 22.1616 59.7287 23.8205C62.6944 25.4808 64.5376 27.8824 64.8563 30.6001C65.1612 33.2748 63.9971 35.9772 61.6134 38.2223C60.1395 37.3014 58.445 36.794 56.7075 36.7533H56.4026C55.6958 36.7671 55.0029 36.8503 54.2823 37.0027C49.0853 38.2084 45.8563 43.3083 47.0481 48.4637C47.7826 51.6511 50.0416 54.0902 52.8964 55.1851L58.3983 79.0494L64.9117 83.0822L69 76.6103L65.7433 74.6008L67.7943 71.3579L64.5376 69.3346L66.5748 66.1056L63.318 64.0822L65.3691 60.8393L63.4982 52.746C65.5908 50.5147 66.547 47.3273 65.8125 44.126C65.4384 42.5045 64.6761 41.0771 63.6229 39.913C66.2422 37.2799 67.7527 33.8845 67.337 30.3229C66.8935 26.5049 64.3435 23.3881 60.8373 21.4382C57.9964 19.8514 54.4902 18.9756 50.7068 19.0005ZM47.9074 37.7788C44.318 37.9312 40.992 40.107 39.5368 43.6271C38.2757 46.6621 38.7053 49.9604 40.3961 52.5242L31 75.1136L33.9519 82.1814L41.0474 79.285L39.5646 75.7511L43.1123 74.3098L41.6433 70.7759L45.1911 69.3346L43.7082 65.8007L47.256 64.3455L50.4158 56.7511C47.5748 55.1573 45.399 52.4272 44.609 49.018C43.6528 44.8189 45.0387 40.6198 47.9074 37.7788ZM55.9453 38.7766C57.1787 38.7627 58.3428 39.2616 59.1882 40.0793C58.426 40.5643 57.5806 40.994 56.6937 41.382C56.4719 41.2988 56.2363 41.2711 55.9869 41.2711C55.9037 41.2711 55.8344 41.2711 55.7651 41.285C54.795 41.3958 54.0744 42.1304 53.9497 43.045C53.922 43.1836 53.922 43.3222 53.922 43.4469C53.9358 43.4885 53.9358 43.5439 53.9358 43.5855C54.0744 44.7496 55.0861 45.5534 56.2502 45.4148C57.1926 45.3039 57.9132 44.5972 58.0518 43.7102C58.911 43.3222 59.7148 42.8926 60.477 42.4075C60.5047 42.5461 60.5325 42.6847 60.5463 42.8233C60.8373 45.3178 59.0219 47.6045 56.5274 47.8955C54.0467 48.1865 51.7462 46.371 51.469 43.8765C51.178 41.382 52.9934 39.0953 55.488 38.8043C55.6404 38.7905 55.7929 38.7766 55.9453 38.7766Z"
              fill="#CDA07D"
            />
          </svg>
          <h2>Open Houses</h2>
        </div>
        <p style={{ marginBottom: 40 }}>
          A well-executed open house can dramatically impact the success of selling your property. Our professional
          realtors are trained to transform your home into a welcoming, immersive experience for potential buyers.
          Instead of merely browsing pictures online, an open house allows visitors to feel the space, envision their
          life within the walls, and create an emotional connection. Our experts meticulously stage each room to
          highlight its best features while providing invaluable insights about the property, neighborhood, and market
          trends.
        </p>
        <p>
          Through real-time feedback and face-to-face interactions, The New Home Collection's realtors can gauge buyer
          interest and adjust strategies accordingly. An open house is not just a viewing; it's a tactile and
          personalized journey curated by our professionals, ensuring that your home leaves a lasting impression,
          pushing it to the forefront of potential buyers' choices.
        </p>
      </div>
      <div className="image">
        <img
          src="https://bucket.ywhdev.com/wl/?id=BbBtOGdBHWi1zVYNggNSIRBZkO409Pqa&fmode=open"
          alt="showing a beautiful 2-storey house."
        />
      </div>
    </Section5Container>
  );
};

export default Section5;
